var app = angular.module("leonardo");

var FieldList = function($scope, $timeout, $q, $attrs, ngDialog, FieldSubgroupService, FilterService, $state,
                         FieldService) {
  $scope.subgroups = [];

  $scope.subgroupExpanded = null;

  $scope.expandSubgroup = function(subgroup, event) {
    $scope.subgroupExpanded = ($scope.subgroupExpanded == subgroup) ? null : subgroup;
    $timeout(function() {
      var scrollTop = angular.element('.wrapper-columns-column.region-main .content-column').scrollTop();
      var eventTop = angular.element(event.target).offset().top;
      angular.element('.wrapper-columns-column.region-main .content-column').animate({scrollTop: eventTop + scrollTop - 120}, "slow");
    }, 100);
  };

  $scope.subgroupIsExpanded = function(subgroup) {
    return $scope.subgroupExpanded == subgroup;
  };

  $scope.getParams = function() {
    var filters = {
      disable_pagination: true
    };
    if (FilterService.hasFilter('sector')) {
      filters['sector'] = FilterService.getFilter('sector');
    }
    if (FilterService.hasFilter('subgroup_name')) {
      filters['name__icontains'] = FilterService.getFilter('subgroup_name');
    }
    return filters;
  };

  $scope.refresh = function() {
    FieldSubgroupService.getlist($scope.getParams()).then(function(data) {
      $scope.subgroups = data;
    });
  };

  $scope.editField = function(field, subgroup){
    FieldService.get(field.id).then(function (data) {
      ngDialog.openConfirm({
        controller: 'FieldEditDialog',
        templateUrl: 'views/templates/dialog/admin/fields/field.html',
        data: {
          field: data,
          subgroup: subgroup
        }
      }).then(function() {
        $scope.refresh();
      });
    });
  };

  $scope.deleteField = function(field){
    FieldService.get(field.id).then(function(data){
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'field'
        }
      }).then(function(res){
        FieldService.updateCollection(res, true);
        $scope.refresh();
      });
    });

  };

  $scope.addField = function(subgroup){
    ngDialog.open({
      controller: 'FieldEditDialog',
      templateUrl: 'views/templates/dialog/admin/fields/field.html',
      data: {
        field: null,
        subgroup: subgroup
      }
    });
  };

  $scope.editSubgroup = function(subgroup){
    FieldSubgroupService.get(subgroup.id).then(function(data){
      ngDialog.open({
        controller: 'SubgroupEditDialog',
        templateUrl: 'views/templates/dialog/admin/fields/subgroup.html',
        data: {
          subgroup: data
        }
      });
    });
  };

  $scope.showDeleteSubgroup = function (subgroup) {
    FieldSubgroupService.get(subgroup.id).then(function(data){
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'subgroup'
        }
      }).then(function(result){
        FieldSubgroupService.updateCollection(result, true);
        $scope.refresh();
      });
    });
  };

  $scope.$on('subgroup:changed', function($event, key, value) {
    $scope.refresh();
  });

  $scope.$on('field:changed', function($event, key, value) {
    $scope.refresh();
  });

  $scope.$on('filter-selection:updated', function() {
    $scope.refresh();
  });

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('FieldList', ['$scope', '$timeout', '$q', '$attrs', 'ngDialog', 'FieldSubgroupService', 'FilterService',
  '$state', 'FieldService', FieldList]);
